import React from 'react';
import { Route } from 'react-router-dom';
import { IAsyncRoute } from 'us.collection/interfaces';
import { CaseType } from 'us.helper/types/enums';

export const asyncRoutes = (
    url: string,
    caseNo: number,
    caseType: CaseType,
    Containers:Array<IAsyncRoute>
  ) => (
    <>
      {Containers.map((container: IAsyncRoute, index: number) => {
        return (
          <Route
            key={container.Route}
            path={`${url}/${container.Route}`}
            element={
              <container.Container
                caseNo={caseNo}
                caseType={caseType}
              />
            }
          />
        );
      })}
    </>
  );